<span
  class="badge"
  [popoverTitle]="hierarchyTitle"
  [ngbPopover]="hierarchy"
  [ngClass]="{
    'bg-warning': currentLevel.status === 0,
    'bg-success': currentLevel.status === 1,
    'bg-danger': currentLevel.status === 2
  }"
  *ngIf="currentLevel"
>
  {{ currentLevel.status === 0 ? "P" : currentLevel.status === 1 ? "A" : "R" }}
</span>

<!-- 🔹 Popover Title -->
<ng-template #hierarchyTitle>
  <div class="d-flex justify-content-between align-items-center">
    <span>Approval History</span>
    <i data-feather="x" size="18px" style="cursor: pointer"></i>
  </div>
</ng-template>

<!-- 🔹 Popover Body -->
<ng-template #hierarchy>
  <ul class="timeline mt-2">
    <li class="timeline-item" *ngFor="let status of statusList">
      <span
        class="timeline-point timeline-point-indicator"
        [ngClass]="{
          'bg-warning': status.status === 0,
          'bg-success': status.status === 1,
          'bg-danger': status.status === 2
        }"
      ></span>

      <div class="timeline-event">
        <div
          class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1"
        >
          <div>
            <h6 class="mb-0 font-weight-bolder">
              {{ status.approverName }}
            </h6>
            <small class="text-muted d-block">
              {{ status.updatedAt | date : "medium" }}
            </small>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <span
            class="badge"
            [ngClass]="{
              'bg-warning': status.status === 0,
              'bg-success': status.status === 1,
              'bg-danger': status.status === 2
            }"
          >
            {{
              status.status === 0
                ? "Pending"
                : status.status === 1
                ? "Approved"
                : "Rejected"
            }}
          </span>

          <span
            class="ml-2 text-muted"
            *ngIf="status.comment"
            [ngbTooltip]="status.comment"
          >
            <i data-feather="message-square" size="14px"></i>
          </span>
        </div>
      </div>
    </li>
  </ul>
</ng-template>
